// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminIdentityApplicationWorkflows = {
  actions: {
    applicationGrantRules: "准入规则",
    roleMappings: "角色映射",
    credentials: "接入凭据",
    roleCatalogs: "角色目录",
    syncRoleCatalog: "同步角色目录",
    memberSnapshots: "成员摘要",
    syncMemberSnapshots: "同步成员摘要",
    syncSourceRequired: "请先在应用 metadata_json.platform_sync_base_url 配置同步 API 地址",
    applicationContext: "应用上下文",
    createGrant: "新建准入规则",
    createRoleMapping: "新建应用角色映射",
    rotateCredential: "轮换接入凭据",
    enableApplication: "启用应用",
    disableApplication: "停用应用",
  },
  drawers: {
    applicationGrant: "应用准入规则 · {name}",
    applicationGrantShort: "应用准入规则",
    applicationRoleMapping: "应用角色映射 · {name}",
    applicationRoleMappingShort: "应用角色映射",
    credentials: "应用接入凭据 · {name}",
    credentialsShort: "应用接入凭据",
    roleCatalogs: "角色目录 · {name}",
    roleCatalogsShort: "角色目录",
    memberSnapshots: "成员摘要 · {name}",
    memberSnapshotsShort: "成员摘要",
    applicationContext: "应用上下文 · {name}",
    applicationContextShort: "应用上下文",
  },
  alerts: {
    credentialIssued: "已生成新 Client Secret，仅本次展示。请立即保存到应用配置。",
    applicationEntryUnitsHint:
      "当前 `exam` 仍是一个业务产品记录，但在接入层按 `exam-admin / exam-candidate` 两个入口理解。",
  },
  confirms: {
    removeApplicationGrantTitle: "删除应用准入规则",
    removeApplicationGrantDescription: "确认删除 {subject} 的 {access} 准入规则吗？",
    updateApplicationStatusTitle: "更新应用状态",
    updateApplicationStatusDescription: "确认将 {application} 更新为 {status} 吗？",
    removeRoleMappingTitle: "删除应用角色映射",
    removeRoleMappingDescription: "确认删除 {from} -> {to} 吗？",
  },
  messages: {
    applicationGrantRemoved: "应用准入规则已删除",
    applicationGrantRemoveFailed: "删除应用准入规则失败",
    roleMappingRemoved: "应用角色映射已删除",
    roleMappingRemoveFailed: "删除应用角色映射失败",
    credentialActivated: "接入凭据已启用",
    credentialActivateFailed: "接入凭据启用失败",
    credentialDeactivated: "接入凭据已停用",
    credentialDeactivateFailed: "接入凭据停用失败",
    applicationUpdated: "应用已更新",
    applicationCreated: "应用已创建",
    applicationUpdateFailed: "应用更新失败",
    applicationCreateFailed: "应用创建失败",
    noTargetApplication: "未选择目标应用",
    applicationGrantCreated: "应用准入规则已创建",
    applicationGrantCreateFailed: "应用准入规则创建失败",
    roleMappingUpdated: "应用角色映射已更新",
    roleMappingCreated: "应用角色映射已创建",
    roleMappingUpdateFailed: "应用角色映射更新失败",
    roleMappingCreateFailed: "应用角色映射创建失败",
    credentialRotated: "接入凭据已轮换",
    credentialRotateFailed: "接入凭据轮换失败",
  },
  forms: {
    applicationGrantCreate: "新建准入规则",
    applicationGrantCreateNamed: "新建准入规则 · {name}",
    roleMappingCreate: "新建角色映射",
    roleMappingEdit: "编辑角色映射 · {name}",
    roleMappingShort: "角色映射",
    applicationOwner: "所属应用",
    applicationDisplayName: "显示名称",
    portalDescription: "门户描述",
    portalGroup: "门户分组",
    applicationName: "内部名称",
    appKey: "关联服务代号",
    baseUrl: "注册表派生入口地址",
    redirectUris: "OIDC 回调地址（redirect_uris）",
    claimScopes: "OIDC Scope（claim_scopes）",
    tokenEndpointAuthMethod: "OIDC 客户端认证方式",
    sortOrder: "排序",
    applicationDisplayNameHelp: "主要用于页面展示和下拉选择，属于相对安全的文案字段。",
    portalDescriptionHelp: "用于门户导航卡片的描述文案；为空时门户继续使用默认说明。",
    portalGroupHelp: "用于决定门户导航显示在“常用入口”还是“更多工具”中。",
    applicationNameHelp: "内部识别名称，建议与当前应用语义保持一致，不建议随意改成无关值。",
    applicationNameLockedHelp: "内部名称主要用于系统内部与兼容字段，现网应用编辑时建议保持只读。",
    appKeyHelp:
      "应填写服务入口注册表里的 service_code，用于把认证配置挂回唯一服务身份；不要把它当作新的入口事实源。",
    appKeyLockedHelp:
      "关联服务代号是接入应用挂回服务注册表的稳定标识，现网应用编辑时不建议变更，否则可能影响登录接入、角色映射和权限读取。",
    baseUrlHelp:
      "仅展示注册表派生的应用入口地址；标准域名、端口和路径应从服务入口注册表维护，不在 Identity 里重复定义。",
    redirectUrisHelp:
      "每行一个完整回调地址；为空时默认使用“注册表派生入口地址 + /c/oidc/callback”。",
    claimScopesHelp: "每行一个 scope；为空时默认仅包含 openid。",
    tokenEndpointAuthMethodHelp:
      "public client 选 none；confidential client 选 client_secret_post 或 client_secret_basic。",
    sortOrderHelp: "用于控制门户入口顺序，数字越小越靠前。",
    applicationStatusHelp: "停用后会影响应用接入治理与可用状态判断，不建议把它当普通文案字段修改。",
    tokenEndpointAuthMethodNone: "none（public client）",
    tokenEndpointAuthMethodClientSecretPost: "client_secret_post",
    tokenEndpointAuthMethodClientSecretBasic: "client_secret_basic",
    grantSubject: "准入主体",
    grantObjectValue: "主体对象",
    accessLevel: "准入级别",
    subjectType: "主体类型",
    subjectValue: "主体值",
    targetBusinessRole: "目标业务角色",
    businessRoleAppOption: "应用业务角色",
    accessOption: "可进入",
    manageOption: "可管理",
    requiredApplicationDisplayName: "请输入显示名称",
    requiredApplicationName: "请输入内部名称",
    requiredAppKey: "请输入关联服务代号",
    requiredGrantSubject: "请选择授权对象",
    requiredObjectValue: "请选择对象值",
    requiredAccessLevel: "请选择授权级别",
    requiredSubjectType: "请选择主体类型",
    selectApplicationOwner: "选择所属应用",
    applicationOwnerEmpty: "尚未选择所属应用",
    applicationOwnerPickerTitle: "选择权限绑定所属应用",
    applicationOwnerPickerEmpty: "暂无可选择的身份应用",
    applicationPickerTitle: "选择身份应用",
    permissionApplicationSnapshotMissing:
      "IdentityPermissionDefinitionRead 缺少 application_name/application_display_name 应用快照",
    requiredTargetBusinessRole: "请输入目标业务角色",
    requiredApplicationOwner: "请选择所属应用",
  },
} as const;

export const platformAdminIdentityWorkflows = {
  actions: {
    refresh: "刷新",
    edit: "编辑",
    remove: "删除",
    archive: "归档",
    customFields: "自定义字段",
    permissionBindings: "权限绑定",
    createTenant: "新建租户",
    createOrganization: "新建组织",
    createRole: "新建平台角色",
    createPermission: "新建权限点",
    createBinding: "新建权限绑定",
    viewRawJson: "原始 JSON",
    viewAuditDetail: "审计详情",
    ...platformAdminIdentityApplicationWorkflows.actions,
  },
  drawers: {
    permissionBinding: "权限绑定 · {name}",
    permissionBindingShort: "权限绑定",
    eventRaw: "事件 #{id}",
    eventRawShort: "原始事件",
    eventAudit: "审计事件 #{id}",
    eventAuditShort: "审计事件",
    ...platformAdminIdentityApplicationWorkflows.drawers,
  },
  confirms: {
    removePermissionBindingTitle: "删除权限绑定",
    removePermissionBindingDescription: "确认删除 {type}:{value} 吗？",
    ...platformAdminIdentityApplicationWorkflows.confirms,
  },
  messages: {
    permissionBindingRemoved: "权限绑定已删除",
    permissionBindingRemoveFailed: "删除权限绑定失败",
    tenantUpdated: "租户已更新",
    tenantCreated: "租户已创建",
    tenantUpdateFailed: "租户更新失败",
    tenantCreateFailed: "租户创建失败",
    organizationUpdated: "组织已更新",
    organizationCreated: "组织已创建",
    organizationUpdateFailed: "组织更新失败",
    organizationCreateFailed: "组织创建失败",
    roleUpdated: "平台角色已更新",
    roleCreated: "平台角色已创建",
    roleUpdateFailed: "平台角色更新失败",
    roleCreateFailed: "平台角色创建失败",
    permissionUpdated: "权限点已更新",
    permissionCreated: "权限点已创建",
    permissionUpdateFailed: "权限点更新失败",
    permissionCreateFailed: "权限点创建失败",
    noTargetPermission: "未选择目标权限点",
    permissionBindingCreated: "权限绑定已创建",
    permissionBindingCreateFailed: "权限绑定创建失败",
    ...platformAdminIdentityApplicationWorkflows.messages,
  },
  forms: {
    permissionCreate: "新建权限点",
    permissionEdit: "编辑权限点 · {name}",
    roleCreate: "新建平台角色",
    roleEdit: "编辑平台角色 · {name}",
    tenantCreate: "新建租户",
    tenantEdit: "编辑租户 · {name}",
    organizationCreate: "新建组织",
    organizationEdit: "编辑组织 · {name}",
    permissionBindingCreate: "新建权限绑定",
    permissionBindingCreateNamed: "新建权限绑定 · {name}",
    tenantScope: "租户范围",
    organizationScope: "组织范围",
    permissionKey: "权限键",
    resourceKey: "资源键",
    actionKey: "动作键",
    roleKey: "角色键",
    tenantName: "租户名称",
    organizationName: "组织名称",
    bindingSubject: "绑定对象",
    platformRoleOption: "平台角色",
    userOption: "具体用户",
    businessRoleOption: "基础身份类型",
    tenantOption: "租户",
    organizationOption: "组织",
    optionalUnboundTenant: "可选，不绑定租户则留空",
    optional: "可选",
    requiredPermissionKey: "请输入权限键",
    requiredDisplayName: "请输入显示名称",
    requiredStatus: "请选择状态",
    requiredRoleKey: "请输入角色键",
    requiredTenantName: "请输入租户名称",
    requiredTenantKey: "请输入租户键",
    requiredOrganizationName: "请输入组织名称",
    requiredOrganizationKey: "请输入组织键",
    requiredPlatformRole: "请选择平台角色",
    requiredBusinessRoleValue: "请输入基础身份类型值",
    requiredPriority: "请输入优先级",
    requiredBindingSubject: "请选择绑定对象",
    requiredBusinessRole: "请输入业务角色",
    ...platformAdminIdentityApplicationWorkflows.forms,
  },
  alerts: {
    ...platformAdminIdentityApplicationWorkflows.alerts,
  },
} as const;
